import React from "react";
import "./BillToPay.css";

export default function BillToPay(props) {
  return (
    <div>
      <h3 className="label">Bill</h3>
      <div className="bill-input-container">
        <input
          onChange={(e) => {
            props.onBillAmount(e.target.value);
          }}
          className="bill-input"
          type="number"
          min="0"
          value={props.billAmount}
        />
      </div>
    </div>
  );
}
